import React from 'react';
import Button, { type ButtonProps } from '@mui/material/Button';

export type AppButtonProps = ButtonProps;

/**
 * MUI Button with design-system defaults: `size="small"` unless overridden.
 * Use `size="medium"` for the primary page-level CTA.
 */
const AppButton = React.forwardRef(function AppButton(
  { size = 'small', ...props }: AppButtonProps,
  ref: React.Ref<HTMLButtonElement>,
) {
  return <Button ref={ref} size={size} {...props} />;
}) as typeof Button;

export default AppButton;
